import api from './api';
export const uploadService = {
    uploadFiles(rmaId, files) {
        const formData = new FormData();
        files.forEach((file) => {
            formData.append('files', file);
        });
        return api.post(`/api/upload/rma/${rmaId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    getFile(fileId) {
        return api.get(`/api/upload/file/${fileId}`, {
            responseType: 'blob',
        });
    },
    deleteFile(fileId) {
        return api.delete(`/api/upload/file/${fileId}`);
    },
};
